import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    FormulaPostRuntype,
    FormulaResponseRuntype,
    FormulaTestPostRuntype,
    FormulaTestResponseRuntype,
} from './formulaBackendTypes';

export const formulaEndpoints = {
    'POST /formula/validate': endpoint({
        description: 'Validates a formula',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: FormulaPostRuntype,
        responseBody: FormulaResponseRuntype,
    }),

    'POST /formula/test': endpoint({
        description: 'Runs a formula with provided values',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: FormulaTestPostRuntype,
        responseBody: FormulaTestResponseRuntype,
    }),
};
